
import styled from 'styled-components';
export const TableWrapper = styled.div`
	overflow: auto;
	border: 1px solid #00297024;
	border-radius: 10px;
	font-size: 11px;
    min-height: 500px;
	/* overflow-y: hidden;
	overflow-x: auto; */
	overflow: auto;
	&::-webkit-scrollbar {
 width: 0;
		height: 0;
}
	 &::-webkit-scrollbar-thumb{
		background: #ffffff5d; 
		transition: all .3s;
		
	}
	&:hover::-webkit-scrollbar-thumb {
		background: #888888a1; 

}
	&.mobile-plan-table {
		max-height: 300px;
	}
	.table {
		width: 100%;
		border-collapse: collapse;
		box-shadow: 0px 2px 3px #0029700d;
		tbody {
			tr {
				border-bottom: 1px solid #00297024;

				&:last-child {
					border-bottom: none;
				}
			}
		}
		th,
		td {
			padding: 10px 10px;
			text-align: center;
			text-transform: capitalize;
            color: black;
			&.text-right {
				text-align: right;
			}
			&.text-center {
				text-align: center;
			}
			&.text-left {
				text-align: left;
			}
            span{
                color: black;
            }
		}
		th {
			background-color: #edfafe;
			border: none;
			white-space: nowrap;
			font-weight: 500;

			&.remark {
				padding: 0 60px;
			}
		}
		td {
			white-space: nowrap;
			.moreOptions{
				position: relative;
				&>svg{
                 width: 24px;
				 cursor: pointer;
				 fill: #00BAF2;
				}
				.options{
					position: absolute;
 
    margin: 0px;
  top: 100%;
  min-width: 100%;
  right: 0;
	background-color: #fff;
					position: absolute;
					visibility: hidden;
					opacity: 0;
					z-index: 10;
					box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
					min-width: 200px;
					border-radius: 8px;
					&.open{
						visibility: visible;
						opacity: 1;
						ul{
							padding: 10px 0px;
							li{
								text-align: left;
								padding: 8px 20px;
								border-bottom: 1px solid #33333326;
								cursor: pointer;
								&:last-child{
									border-bottom: none;
								}
							}
						}
					}
				}

			}
			.select-link > div {
				display: inline-block;

				color: #00baf2;
				border: 2px solid #00baf2;
				padding: 5px 15px;
				text-align: center;
				min-width: 100px;
				border-radius: 2px;
				white-space: nowrap;
				cursor: pointer;
			}
			&.remark {
				white-space: normal;
				text-align: center;
			}
			&.fail {
				color: red;
			}
			&.success {
				color: green;
			}
			.image-with-text {
				display: flex;
				align-items: center;
				img {
					margin-right: 10px;
				}
			}
			.payment-btn {
    width: 76px;
    height: 20px;
    border-radius: 10px;
    border: 1px solid rgb(223, 223, 223);
    display: flex
;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    font-size: 10px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.5s;
    margin-right: 4px;
	
	&>span {
    width: 14px;
    height: 14px;
    display: flex
;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 2px;
    background-color: #00BAF2;
    color: rgb(255, 255, 255);
    padding: 1px 1px 0px 0px;
	}
}
		}
		.card-th{
			display: none;
		}
	}
	@media only screen and (max-width: 767px){
		padding: 20px;
		margin-inline: -20px;
		&.table-card-wrapper{
			border: none;
		
	
			.table{
				
				thead{
					display: none;
				}
				tbody{
                    tr{
				
						margin: 0px auto 20px;
					  
							border-bottom: none;
							background-color: #f9f9f9;
							border-radius: 10px;
							padding: 20px 10px;
							box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
						display: block;
						td{
							padding: 4px 10px;
							display: flex;
							justify-content: space-between;
							&>span.card-th{
                               display: block;
							   font-weight: 600;
                               color: black;
    
							}
							&>span:last-child{
								font-weight: normal;
                                color: black;
							}
							&.td-none{
								display: none;
							}
						}
					}
				}

			}
		}

	}
	
`;